import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Page from '../../components/Page';
import Panel from '../../components/Panel';
import ChangePassword from '../../pages/auth/ChangePassword';
import StatusMessages from '../../components/StatusMessages';
import BlankState from '../../components/BlankState';

import { updateUserProfile } from '../../actions/user';

class Profile extends Component{

	constructor(props){
		super(props);

		const { id, name } = this.props.user.userInfo;
		const names = name.split(' ');

		const user = {
			first_name: names[0],
			last_name: names[1],
			...this.props.user.userInfo
		};

		this.state = {
			showEditForm: false,

			user: {
				...user
			},
			updated_user: { id }
		};
	}

	toggleEditForm = (e) => {
		this.setState({
			showEditForm: !this.state.showEditForm
		});
	}

	onChange = (e) => {
		e.preventDefault();

		const { user, updated_user } = this.state;
		let { name, value, files } = e.target;

		if(files){
			value = files[0];
		}

		this.setState({
			user: {
				...user, 
				[name]: value 
			},
			updated_user: {
				...updated_user, 
				[name]: value
			}
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		const { updated_user } = this.state;

		this.props.updateUserProfile(updated_user);
	}

	formatRole(roles){
		let role = roles.length > 0 ? roles[0] : '';

		return role.replace('_', ' ').toUpperCase();
	}

	render(){
		const { user, showEditForm } = this.state;
		const { update_profile_loading, errorMessageUpdateProfile, successMessageUpdateProfile  } = this.props.user;

		const fullname = `${user.first_name} ${user.last_name}`;

		const userPhoto = typeof user.photo === 'object' ? window.URL.createObjectURL(user.photo) : user.photo;

		return(
			<Page 
				isAdminPage={ true } 
				pageTitle="My Profile">
				
				<div className="row">
					<div className="col-sm-6 profile-holder">
						<Panel title="Basic Details">
							<span 
								className="btn btn-sm pull-right toggle-edit-profile" 
								onClick={ this.toggleEditForm }>

								{ 
									showEditForm ? 
										<span className="text-danger">
											<i className="icon ion-close"></i> &nbsp;Close
										</span>
									:
										<span className="text-danger">
											<i className="icon ion-edit"></i>  &nbsp;Edit
										</span>
								}
							</span>
						
							{ !showEditForm ?
							
							<div className="row">
								<div className="col-sm-4">
									<p>
										<img 
											className="img-responsive"
											src={ userPhoto } 
											alt={ fullname } />
									</p>
								</div>

								<div className="col-sm-8">
									<h3>{ fullname }</h3>
									<p>Email: { user.email }</p>
									<p>Phone: <a href={ "tel:" + user.phone } >{ user.phone }</a></p>
								</div>
							</div>
						:
							<form 
								className="form-horizontal" 
								onSubmit={ this.onSubmit }>

								{
									errorMessageUpdateProfile && !update_profile_loading ?
										<StatusMessages type="error" message={ errorMessageUpdateProfile } />
									: null
								}
								{
									successMessageUpdateProfile && !update_profile_loading ?
										<StatusMessages type="success" message={ successMessageUpdateProfile } />
									: null
								}
								
								<BlankState 
									data={ false }
									isDataLoading={ update_profile_loading }
									customMessage="Updating profile..." />
								
								<div className="col-sm-12">
									<div className="form-group">
										<label className="control-label col-sm-4">Photo</label>
										<div className="col-sm-8">
											<img
												className="img-responsive"
												ref="profilePhoto"
												src={ userPhoto } 
												alt={ fullname } />
										
											<label className="btn btn-default btn-sm btn-upload">
												<input 
													type="file" 
													name="photo"
													accept="image/*"
													placeholder="Upload a profile pic"
													onChange={ this.onChange } />

												<i className="icon ion-image"></i> &nbsp;Change image
											</label>
											
											<br/>
										</div>
									</div>

									<div className="form-group">
										<label className="control-label col-sm-4">First Name</label>
										<div className="col-sm-8">
											<input 
												type="text" 
												name="first_name" 
												className="form-control" 
												required
												value={ user.first_name }
												onChange={ this.onChange } />
										</div>
									</div>

									<div className="form-group">
										<label className="control-label col-sm-4">Last Name</label>
										<div className="col-sm-8">
											<input 
												type="text" 
												name="last_name" 
												className="form-control" 
												required
												value={ user.last_name }
												onChange={ this.onChange } />
										</div>
									</div>

									<div className="form-group">
										<label className="control-label col-sm-4">Email</label>
										<div className="col-sm-8">
											<input 
												type="email" 
												name="email" 
												className="form-control" 
												required
												value={ user.email }
												onChange={ this.onChange } />
										</div>
									</div>

									<div className="form-group">
										<label className="control-label col-sm-4">Phone</label>
										<div className="col-sm-8">
											<input 
												type="text" 
												name="phone" 
												className="form-control" 
												required
												value={ user.phone }
												onChange={ this.onChange } />
										</div>
									</div>
									
									<div className="col-sm-12">
										<button className="btn btn-warning col-sm-offset-4">
											<i className="icon ion-checkmark"></i> &nbsp;
											Update Profile
										</button>
									</div>
								</div>
							</form>
							}
						</Panel>
					</div>

					<div className="col-sm-6">
						<Panel title="Change Password">
							<div className="row">
								<ChangePassword />
							</div>
						</Panel>
					</div>
				</div>
			</Page>
		);
	}
}
const mapStateToProps = (state, ownProps) => ({
	user: state.user
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ updateUserProfile }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);


// WEBPACK FOOTER //
// ./src/pages/user/Profile.jsx